import { observer } from "mobx-react";
import _ from "lodash";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useStores } from "../../stores/root-store";
import AddOnsListing from "./addOns-listing";
import AddOnForm from "./addOn-form";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ManageAddOns = observer(() => {
  const { addOnStore } = useStores();
  const { editAddOn, setEditAddOn } = addOnStore;
  const [showAddOnsForm, setShowAddOnsForm] = useState(false);

  const handleAddOnsFormClose = (show: boolean) => {
    setShowAddOnsForm(show);
    if (!show) setEditAddOn(null);
  };

  useEffect(() => {
    if (editAddOn) setShowAddOnsForm(editAddOn.addOnId > 0);
  }, [editAddOn]);

  return (
    <div className="mt-3 pb-3">
      <div className="row mb-3">
        <h5 className="mb-0 text-start">
          Product Add-Ons
          <Button
            onClick={() => setShowAddOnsForm(true)}
            className="btn-default float-end"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Add New
          </Button>
        </h5>
      </div>
      <AddOnsListing />
      {showAddOnsForm && (
        <AddOnForm show={showAddOnsForm} setShowModal={handleAddOnsFormClose} />
      )}
    </div>
  );
});

export default ManageAddOns;
